/**
 * Gets the positioning offsets for border layers
 */
export function getBorderLayerOffsets(): { first: number; second: number } {
  return {
    first: 18, // First border layer offset (16px border + 2px gap)
    second: 34, // Second border layer offset (16px + 16px, no gap between borders)
  }
}

/**
 * Gets the border radius for each layer
 */
export function getBorderLayerRadius(baseRadius: string): { first: string; second: string } {
  const baseRadiusNum = parseInt(baseRadius)
  return {
    first: `${baseRadiusNum + 18}px`, // First layer: base + 18px offset
    second: `${baseRadiusNum + 34}px`, // Second layer: base + 34px offset
  }
}
